module.exports = __webpack_public_path__ + "static/media/CNX.8ce75e93.png";